import { ChangeDetectorRef, Component, EventEmitter, HostListener, Output, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { stripSensitiveQueryParams } from 'src/app/shared/common/strip-sensitive-query-params.util';
import { BehaviorSubject, combineLatest, debounceTime, distinctUntilChanged, map, Observable, of, startWith, Subject, takeUntil, } from 'rxjs';
import { AccountService } from 'src/app/services/accountService/account.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { RegistationUtilitiesService } from '../../services/registation-utilities.service';
import { AuthServiceService } from 'src/app/services/authService/auth-service.service';
import { jwtDecode } from 'jwt-decode';
import { OtpRequestPayload, } from 'src/app/models/interface/Registration/registration';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { ContentService } from 'src/app/modules/cam/services/content.service';
import { LinkAccountDialogComponent } from '../link-account-dialog/link-account-dialog.component';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { HttpClient } from '@angular/common/http';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { ThankyouService } from 'src/app/shared/common/thankyou.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { environment } from 'src/environments/environment';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { DateOfBirthCalendarComponent } from '../date-of-birth-calendar/date-of-birth-calendar.component';
import { ExpiryDateComponent } from '../../../cam/components/expiry-date/expiry-date.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RsaService } from 'src/app/services/commonService/rsa.service';


export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}

/**
 * @title Basic select
 */

@Component({
  selector: 'app-admin-info',
  templateUrl: './admin-info.component.html',
  styleUrls: ['./admin-info.component.scss'],
  imports: [ReactiveFormsModule, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgIf, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatError, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, DateOfBirthCalendarComponent, ExpiryDateComponent, MatSelect, NgFor, MatOption, MatRadioGroup, MatRadioButton, MatIconButton, MatSlideToggle, MatCheckbox, MatButton, MatProgressSpinner, DatePipe]
})
export class AdminInfoComponent implements OnInit, OnDestroy {
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  travelerSignupForm: FormGroup;
  newCustomCountries: any[] = [];
  countriesLists: any[] = [];
  filteredCountries: any;
  stateGroupOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  NationalityOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  PreviousCountryCode: any;
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  branchId!: number;
  branchName!: string;
  branchList: any[] = [];
  designationsList: any[] = [];
  departmentsList: any[] = [];
  selectedExpiryDate: Date | null = null;
  alfursantoggle: boolean = false;
  isFederatedAccount: boolean = false;

  private readonly destroy$ = new Subject<void>();
  elmVerified: boolean = false;
  elmVerificationDate: Date | null = null;
  @Output() existEmail = new EventEmitter<{ exists: boolean; email: string }>();
  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false,
    isExpiaryCalendarVisible: false,
    // Add other child components here
  };
  titleOptions = [
    { value: 'Mr', viewValue: 'Mr' },
    { value: 'Mrs', viewValue: 'Mrs' },
    { value: 'Ms', viewValue: 'Ms' },
    { value: 'Miss', viewValue: 'Miss' },
    { value: 'Mstr', viewValue: 'Mstr' },
  ];

  CommonObj = {
    docType: '',
    docName: '',
  };
  commonObj: any = {
    isSubmitting: false,
    fakeRes: '',
  };
  token!: any;
  content: any;
  onBoardContent: any;
  userTypes: any;
  titles: any[] = [];
  // ThankyouService: any;
  constructor(
    private readonly fb: FormBuilder,
    public readonly _ApiService: ApiService,
    public readonly _CommonService: CommonService,
    private readonly _Router: Router,
    private readonly _ActivatedRoute: ActivatedRoute,
    private readonly _AccountService: AccountService,
    private readonly _MatDialog: MatDialog,
    private readonly _RegistationUtilitiesService: RegistationUtilitiesService,
    private readonly authService: AuthServiceService,
    private readonly contentService: SignUpContentServiceService,
    private readonly onBoardContentService: ContentService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly http: HttpClient,
    private readonly _dataLayerService: DataLayerService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly ThankyouService: ThankyouService,
    private readonly cd: ChangeDetectorRef,
    private readonly _CamService: CamService,
    private readonly _RsaService: RsaService
  ) {
    this.travelerSignupForm = this.fb.group({
      Nationality: [null, Validators.required],
      residence: [null, Validators.required],
      identityNumber: [''],
      countryCode: [null, Validators.required],
      docExpiary: ['', [Validators.required]],
      dateOfBirth: ['', Validators.required],
      title: ['', Validators.required],
      firstname: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      lastname: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      gender: ['Male'],
      empCode: [
        '',
        [Validators.required, Validators.minLength(4), Validators.maxLength(9)],
      ],
      email: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(30)],
      ],
      mobileNumber: ['',[Validators.minLength(8), Validators.maxLength(12)]],
      branch: ['', [Validators.required]],
      department: [''],
      designation: ['', [Validators.required]],
      userType: ['0', Validators.required],
      password: [
        '',
        [
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(8),
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
          ),
          this.passwordMatchValidator.bind(this)
        ],
      ],
      confirmPassword: [
        '',
        [Validators.required, this.passwordMatchValidator.bind(this)],
      ],
      alfursanOptIn: [false],
      alfursanID: [''],
      acceptTerms: [false, [Validators.requiredTrue]],
      agreeConcent: [false, [Validators.requiredTrue]],
      acceptPrivacy: [false, [Validators.requiredTrue]],
      receiveOffers: [false],
      userGuid: [''],
      saUserId: [''],
      subagentId: [''],
      accountID: [''],
    });
  }
  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        console.log('response of forkJoin', res);
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
        this.getSiteCoreArray('b2b.register.titledropdown')
      });

    this.onBoardContentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.onBoardContent = res;
      });


    this.travelerSignupForm.get('password')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.travelerSignupForm.get('confirmPassword')?.updateValueAndValidity();
    })

    let urlToken = this._ActivatedRoute.snapshot.queryParamMap.get('token');
    if (urlToken) {
      this.token = urlToken;
      sessionStorage.setItem('temp_onboarding_token', urlToken);
      stripSensitiveQueryParams(this._Router, this._ActivatedRoute, ['token']);
    } else {
      this.token = sessionStorage.getItem('temp_onboarding_token');
    }
    console.log(this.token);

    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.newCustomCountries =
          this._CommonService.groupCountriesFilter($res);
        this.groupCountries($res);
      })
      .catch(($err) => { });

    this.travelerSignupForm
      .get('Nationality')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this.filterCountries(value)),
      )
      .subscribe((filteredCountries) => {
        this.filteredCountries = filteredCountries;
        this.groupCountries(this.filteredCountries);
      });
    this.authService.getTokenbeforeLogin().subscribe((res: any) => {
      const tokenData = res.data;
      localStorage.setItem('token_type', tokenData.token_type);
      localStorage.setItem('access_token', tokenData.access_token);
      localStorage.setItem('expires_in', tokenData.expires_in);
      localStorage.setItem('session_id', tokenData.session_id);
      localStorage.setItem('scope', tokenData.scope);

    });
    this.authService.getTokenbeforeLogin().subscribe(() => {

    }, (error: any) => {

    })
    //check email existing or not
    if (this.token) {
      try {
        const decoded: any = jwtDecode(this.token);
        this.isFederatedAccount = decoded?.isFederatedAccount === 'True';
        if (this.isFederatedAccount) {
          this.travelerSignupForm.get('password')?.clearValidators();
          this.travelerSignupForm.get('password')?.updateValueAndValidity();
          this.travelerSignupForm.get('confirmPassword')?.clearValidators();
          this.travelerSignupForm.get('confirmPassword')?.updateValueAndValidity();
        }
      } catch (e) {
        console.error('Invalid token', e);
      }
    }
    this.travelerSignupForm
      .get('Nationality')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.travelerSignupForm.get('Nationality')?.value,
          this.travelerSignupForm.get('residence')?.value,
        );
        this.verifyELM('nn');
      });

    this.travelerSignupForm
      .get('residence')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.travelerSignupForm.get('Nationality')?.value,
          this.travelerSignupForm.get('residence')?.value,
        );
        this.verifyELM('nn');
      });


    // this.travelerSignupForm.get('countryCode')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
    //   this.updatePhoneNumberValidators()
    // })

    // // Initial call to set validators
    // this.updatePhoneNumberValidators();


    this._RegistationUtilitiesService
      .travelerOnboaringDetails(this.token)
      .subscribe(
        (res) => {
          const responseData = res.data;
          this.branchId = Number(responseData.branchId);
          this.branchName = responseData.branchName;

          this.branchList = responseData.branches;
          this.departmentsList = responseData.departments;
          this.designationsList = responseData.designations;

          this.travelerSignupForm.get('email')?.disable();
          this.travelerSignupForm.get('userType')?.disable();
          this.travelerSignupForm.get('firstname')?.disable();
          this.travelerSignupForm.get('lastname')?.disable();
          this.travelerSignupForm.get('empCode')?.disable();
          this.travelerSignupForm.get('branch')?.disable();
          this.travelerSignupForm.get('department')?.disable();
          this.travelerSignupForm.get('designation')?.disable();
          this.travelerSignupForm.patchValue({
            Nationality: responseData.passportNationality || null,
            residence: responseData.placeOfResidence || null,
            identityNumber: responseData.nationalId,
            dateOfBirth: this.convertDateFormat(responseData.dateOfBirth),
            title: responseData.title,
            firstname: responseData.userFirstName,
            lastname: responseData.userLastName,
            gender: responseData.gender,
            empCode: responseData.employeeCode,
            email: responseData.emailAddress,
            mobileNumber: responseData.mobileNumber,
            branch: responseData.branchId,
            department: responseData.departmentId || null,
            designation: responseData.designationId || null,
            userType: responseData.userType,
            countryCode: responseData.phoneExtension || null,
            docExpiary: this.convertDateFormat(responseData.docExpiry),
            userGuid: responseData.userGuid,
            saUserId: responseData.saUserId,
            subagentId: responseData.subagentId,
            accountID: responseData.accountId,
          });
          this.userTypes = responseData.userType == '0' ? 'Admin' : responseData.userType == '1' ? 'Travel Arranger' : 'Employee';
          this._dataLayerService.langdingPageOnboard(responseData.userType == '0' ? 'Admin' : responseData.userType == '1' ? 'Travel Arranger' : 'Employee');
          this.updateDocumentType(
            responseData.passportNationality,
            responseData.placeOfResidence,
          );

          this.travelerSignupForm.updateValueAndValidity();
          // this.travelerSignupForm.markAllAsTouched()

        },
        (error) => {
          if (error.error.status === 'Failure') {
            const decoded: any = jwtDecode(this.token);
            const email = decoded.email;
            this.existEmail.emit({
              exists: true,
              email: email,
            });
            return;
          }

          if (error.error.status == 'Unauthorized') {
            this._ToastrApiService.show('error', error.error.message);
            // this._Router.navigate(['/linkExpired']);
            //gtm use
            const decoded: any = jwtDecode(this.token);
            const userType = decoded?.userType == '0' ? 'Admin' : decoded?.userType == '1' ? 'Travel Arranger' : 'Employee';
            // this._Router.navigate(['/linkExpired'], { queryParams: { userType } });
            // decode token here
            this._Router.navigate(['/linkExpired'], {
              queryParams: {
                userType: this.userTypes,
                token: this.token,   // 👈 IMPORTANT
                navigateFrom: 'CreateContact'
              }
            });

            this.travelerSignupForm.disable();
          }
        },
      );

    this.getFakeJson();
  }
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event) {
    const target = event?.target as HTMLElement;
    const isDobInput = target.getAttribute('formControlName');
    if (!isDobInput) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.isChildVisible['isExpiaryCalendarVisible'] = false;
    }
  }
  groupCountries(data: any): void {
    if (!this.countriesLists?.length) {
      this.countriesLists = data;
    }
    this.filteredCountries = data;
    const grouped: {
      [key: string]: {
        name: string;
        code: string;
        isdCode: string;
        countryFlag: string;
      }[];
    } = this.filteredCountries?.reduce(
      (acc: any, country: any) => {
        const firstLetter = country.countryName[0].toUpperCase(); // Use countryName instead of Country
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
        acc[firstLetter].push({
          name: country.countryName,
          code: country.isoCode,
          isdCode: country.code,
          countryFlag: country.newFlag.src,
        });
        return acc;
      },
      {} as {
        [key: string]: {
          name: string;
          code: string;
          isdCode: string;
          countryFlag: string;
        }[];
      },
    );
    if (this.filteredCountries) {
      const sortedGroupLetters = Object.keys(grouped).sort((a, b) =>
        a.localeCompare(b),
      );
      const saudiGroup = grouped['S']?.find((c) => c.name === 'Saudi Arabia');
      if (saudiGroup) {
        grouped['S'] = grouped['S'].filter((c) => c.name !== 'Saudi Arabia');
        grouped['S'] = [
          {
            name: 'Saudi Arabia',
            code: 'SA',
            isdCode: '+966',
            countryFlag:
              '/-/media/SaudiaWebApp/data/media/img/Flags/Latest-flags/Flag-saudi_arabia.ashx?rev=856c905ee3344e1295e5948ae4d64d9a',
          },
          ...grouped['S'],
        ];
        const index = sortedGroupLetters.indexOf('S');
        if (index > -1) {
          sortedGroupLetters.splice(index, 1);
        }
        sortedGroupLetters.unshift('S');
      }

      // Wrap the result in `of()` to make it an Observable
      this.stateGroupOptions = of(
        sortedGroupLetters.map((letter) => {
          return {
            letter: letter,
            names: grouped[letter],
          };
        }),
      );
    }
  }

  filterCountries(value: any): void {
    const searchField =
      value?.stateGroup?.split('+')?.length === 1
        ? 'countryName'
        : 'code';

    const searchValue = (value?.stateGroup || '')
      .replace('+', '')
      .toLowerCase();

    const currentState: any[] = this.countriesLists.filter(
      ($country: any) =>
        $country[searchField]
          ?.toString()
          .toLowerCase()
          .includes(searchValue)
    );

    this.groupCountries(currentState);

    if (currentState.length < 2) {
      this.PreviousCountryCode = currentState;
    }
  }
  showComponent(componentKey: string, controlName?: string) {
    if (!Object.hasOwn(this.isChildVisible, componentKey)) {
      return;
    }
    Object.keys(this.isChildVisible).forEach((key) => {
      this.isChildVisible[key] = key === componentKey;
    });
    if (!!controlName) {
      // this.travelerSignupForm.get(controlName)?.removeValidators([Validators.required]);
      // this.travelerSignupForm.get(controlName)?.updateValueAndValidity();;
    }
  }
  onDateSelected(event: any): void {
    if (event.isCalenderShow === true) {
      const date = event.date ? new Date(event.date) : null; // Ensure date is valid or null
      const dobDateControl = this.travelerSignupForm.get('dateOfBirth');
      if (date) {
        // Format the date and set it in the form control
        const formattedDate = this.getFormattedDate(date);
        dobDateControl?.setValue(formattedDate); // Update the form control value
        dobDateControl?.clearValidators(); // Clear validators for a valid date
      } else {
        // Handle the case when the date is null
        dobDateControl?.setValue(null);
      }
      // Update form control validation status
      dobDateControl?.updateValueAndValidity();
      // Hide the DOB calendar
      this.isChildVisible['isDOBCalendarVisible'] = false;
    }
    this.verifyELM('nn');
  }
  onDateSelected2(
    event: { type: string; date: Date | null },
    key: string,
  ): void {
    if (event.type === 'dob') {
      if (
        !event.date ||
        event.date.toDateString() === new Date(0).toDateString()
      ) {
        return;
      }
      this.selectedExpiryDate = event.date ? new Date(event.date) : null;
      const formattedDate = this.getFormattedDate(this.selectedExpiryDate);
      this.travelerSignupForm.get('docExpiary')?.setValue(formattedDate);
      if (Object.hasOwn(this.isChildVisible, key)) {
        this.isChildVisible[key] = false;
      }
    }
  }
  getFormattedDate(date: Date | null): string | null {
    if (!date) return null;
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  togglePasswordVisibility(event: MouseEvent) {
    event.preventDefault(); // Prevent default form submission
    this.hideNewPassword = !this.hideNewPassword; // Toggle newPassword visibility
  }
  togglePasswordVisibility1(event: MouseEvent) {
    event.preventDefault(); // Prevent default form submission
    this.hideConfirmPassword = !this.hideConfirmPassword; // Toggle newPassword visibility
  }
  convertToISODate(dob: string): string {
    if (!dob) return '';
    // Split the date into day, month, and year
    const dateParts = dob.split('/');
    // If the format is correct, return the date in the desired format (YYYY-MM-DD)
    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      // Ensure the month and day are zero-padded to 2 digits
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dob; // If the format is incorrect, return the original string
  }

  private buildELMPayload(): any | null {
    const dob = this.travelerSignupForm.get('dateOfBirth')?.value;
    const identity = this.travelerSignupForm.get('identityNumber')?.value;
    const nationality = this.travelerSignupForm.get('Nationality')?.value;
    if (!dob || !identity) return null;
    const formattedDob = this.convertToISODate(dob);
    switch (this.CommonObj.docType) {
      case 'nationalID':
        return {
          nationalID: identity,
          nationality: nationality,
          dateOfBirth: formattedDob,
        };
      case 'iqama':
        return {
          iqama: identity,
          dateOfBirth: formattedDob,
        };
      default:
        return null; // passport → no ELM call
    }
  }
  verifyELM(_: any): void {
    console.log(this.CommonObj.docType)
    const nationality = this.travelerSignupForm.get('Nationality')?.value;
    const residence = this.travelerSignupForm.get('residence')?.value;

    const firstNameControl = this.travelerSignupForm.get('firstname');
    const lastNameControl = this.travelerSignupForm.get('lastname');

    // ✅ If nationality or residence is empty → allow manual entry
    if (!nationality || !residence || !this.CommonObj.docType) {
      firstNameControl?.enable();
      lastNameControl?.enable();
      return;
    }

    if (this.CommonObj.docType === 'passport') {
      this.travelerSignupForm.get('firstname')?.enable();
      this.travelerSignupForm.get('lastname')?.enable();
      return;
    }
    this.travelerSignupForm.get('firstname')?.disable();
    this.travelerSignupForm.get('lastname')?.disable();
    const payload = this.buildELMPayload();
    if (!payload) return;
    this._AccountService.VerifyELMV1(payload).subscribe(
      (response) => {
        if (response?.data?.firstName) {
          this.travelerSignupForm.patchValue({
            firstname: response.data.firstName,
            lastname: response.data.lastName,
          });
        }
        this.elmVerified = true;
        this.elmVerificationDate = new Date();
        this.travelerSignupForm.get('identityNumber')?.setErrors(null);
      },
      (error) => {
        const ctrl = this.travelerSignupForm.get('identityNumber');
        ctrl?.setErrors({
          ...(ctrl?.errors || {}),
          elmError: true,
        });
        this.travelerSignupForm.patchValue({
          firstname: '',
          lastname: '',
        });
        ctrl?.markAsTouched();
      },
    );
  }
  onConfirm(componentKey: string) {
    this.verifyELM('nn');
    if (Object.hasOwn(this.isChildVisible, componentKey)) {
      this.isChildVisible[componentKey] = false;
    }
  }
  // onSubmit() {
  //   if (this.travelerSignupForm.invalid) {
  //     return;
  //   }

  //   const payload = {
  //     "email": this.travelerSignupForm.get('email')?.value,
  //     "mobile": this.travelerSignupForm.get('mobileNumber')?.value,
  //     "id": this.travelerSignupForm.get('identityNumber')?.value,
  //     "IDtype": this.CommonObj.docType,
  //     "nationality": this.travelerSignupForm.get('Nationality')?.value,
  //     // "fursanId": "FUR1234567"
  //   }

  //   const sessionID = localStorage.getItem('session_id');
  //   const token = localStorage.getItem('access_token');

  //   this._RegistationUtilitiesService.fetchMatching(sessionID, token, payload).subscribe((res: any) => {
  //     const hasMatch = Array.isArray(res?.data) && res.data.length > 0;
  //     if (hasMatch) {
  //       this._MatDialog.open(LinkAccountDialogComponent, {
  //         data: {
  //           matches: res.data,  // Renamed for clarity
  //           elmStatus: this.elmVerified,
  //           fullName: `${this.travelerSignupForm.get('firstname')?.value} ${this.travelerSignupForm.get('lastname')?.value}`
  //         }
  //       });

  //     } else {
  //       this._MatDialog.open(EmailVerificationComponent, {
  //         data: {
  //           data: this.travelerSignupForm.value,
  //           Email: this.travelerSignupForm.get('email')?.value,
  //           EmpType: this.travelerSignupForm.get('userType')?.value,
  //           verifyMode: 'EMAIL',
  //           actionType: OtpActionType.LINK_ACCOUNT,
  //           idType: this.CommonObj.docName,
  //           token: localStorage.getItem('access_token'),
  //           sessionID: localStorage.getItem('session_id'),
  //           elmStatus: this.elmVerified,
  //           ConsentTCPP: !!(this.travelerSignupForm.get('acceptTerms')?.value && this.travelerSignupForm.get('agreeConcent')?.value),
  //           ConsentMarketing: this.travelerSignupForm.get('acceptPrivacy')?.value,
  //           expiryDate: this.travelerSignupForm.get('docExpiary')?.value

  //         }
  //       });
  //     }
  //   })

  // }

  onSubmit() {
    const user = this.travelerSignupForm.get('userType')?.value;
    const alfursanID = this.travelerSignupForm.get('alfursanID')?.value;
    this._dataLayerService.onboardingCancleClick('Save', user == '0' ? 'Admin' : user == '1' ? 'Travel Arranger' : 'Employee', this.alfursantoggle, this.travelerSignupForm.get('alfursanID')?.value);
    if (this.travelerSignupForm.invalid) {
      return;
    }

    this.commonObj.isSubmitting = true;
    const mobile = this.travelerSignupForm.get('mobileNumber')?.value;
    const code = this.travelerSignupForm.get('countryCode')?.value;

    // Simple if-else
    let payload;
    if (this.alfursantoggle && alfursanID && alfursanID.trim()) {
      payload = { fursanId: alfursanID };  // Sirf fursanId
    } else {
      payload = {  // Sab fields
        mobile: `${code}${mobile}`,
        id: this.travelerSignupForm.get('identityNumber')?.value,
        IDtype: this.CommonObj.docType,
        nationality: this.travelerSignupForm.get('Nationality')?.value,
        // fursanId: alfursanID
      };
    }

    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');

    this._RegistationUtilitiesService
      .fetchMatching(sessionID, token, payload)
      .subscribe((res: any) => {
        if (this.alfursantoggle && alfursanID && alfursanID.trim() && res?.data?.matchedContacts?.length === 0) {
          this.travelerSignupForm.get('alfursanID')?.setErrors({ wrong: true });
          this.commonObj.isSubmitting = false;
          return; // Stop here
        }

        if (this.alfursantoggle && alfursanID && alfursanID.trim() && res?.data?.matchedContacts?.length > 0) {

          const secondPayload = {
            mobile: `${code}${mobile}`,
            id: this.travelerSignupForm.get('identityNumber')?.value,
            IDtype: this.CommonObj.docType,
            nationality: this.travelerSignupForm.get('Nationality')?.value,
            fursanId: alfursanID
          };

          this._RegistationUtilitiesService
            .fetchMatching(sessionID, token, secondPayload)
            .subscribe((secondRes: any) => {

              const hasMatch =
                Array.isArray(secondRes?.data?.matchedContacts) &&
                secondRes.data.matchedContacts.length > 0;

              if (hasMatch) {
                this._MatDialog.open(LinkAccountDialogComponent, {
                  disableClose: true,
                  data: {
                    matches: secondRes.data,
                    elmStatus: this.elmVerified,
                    elmVerificationDate: this.elmVerificationDate,
                    fullName: `${this.travelerSignupForm.get('firstname')?.value} ${this.travelerSignupForm.get('lastname')?.value}`,
                    data: this.travelerSignupForm.getRawValue(),
                    idType: this.CommonObj.docType,
                    token: token,
                    sessionID: sessionID,
                    ConsentTCPP: !!(
                      this.travelerSignupForm.get('acceptTerms')?.value &&
                      this.travelerSignupForm.get('agreeConcent')?.value
                    ),
                    ConsentMarketing:
                      this.travelerSignupForm.get('acceptPrivacy')?.value,
                    expiryDate: this.travelerSignupForm.get('docExpiary')?.value,
                    authType: 'Onboard'
                  },
                });
              } else {
                this.createContact();
              }

              this.commonObj.isSubmitting = false;
            });

          return;

        }


        const hasMatch =
          Array.isArray(res?.data?.matchedContacts) &&
          res?.data?.matchedContacts.length > 0;

        // const hasMatch = 0 < 5;
        // const userType = user == '0' ? 'Admin' : user == '1' ? 'Travel Arranger' : 'Employee';
        // this._dataLayerService.onboarding_authentication_click('sms', 'Thank you for joining Saudia Business', 0, userType);naz
        // this._dataLayerService.langdingPageOnboard(userType);
        if (hasMatch) {
          this._MatDialog.open(LinkAccountDialogComponent, {
            disableClose: true,
            data: {
              matches: res.data, // Renamed for clarity
              // matches: this.commonObj?.fakeRes,  // Renamed for clarity
              elmStatus: this.elmVerified,
              elmVerificationDate: this.elmVerificationDate,
              fullName: `${this.travelerSignupForm.get('firstname')?.value} ${this.travelerSignupForm.get('lastname')?.value}`,
              data: this.travelerSignupForm.getRawValue(),
              idType: this.CommonObj.docType,
              token: token,
              sessionID: sessionID,
              ConsentTCPP: !!(
                this.travelerSignupForm.get('acceptTerms')?.value &&
                this.travelerSignupForm.get('agreeConcent')?.value
              ),
              ConsentMarketing:
                this.travelerSignupForm.get('acceptPrivacy')?.value,
              expiryDate: this.travelerSignupForm.get('docExpiary')?.value,
              authType: 'Onboard'
            },
          });

          this.commonObj.isSubmitting = false;
        } else {
          // this.sendOTP().subscribe({
          //   next: (otpRes: any) => {
          //     const otpChecksum = otpRes?.data?.checksum || null;

          //     this._MatDialog.open(EmailVerificationComponent, {
          //       data: {
          //         data: this.travelerSignupForm.getRawValue(),
          //         Email: this.travelerSignupForm.get('email')?.value,
          //         EmpType: this.travelerSignupForm.get('userType')?.value,
          //         verifyMode: 'email',
          //         actionType: OtpActionType.LINK_ACCOUNT,
          //         // ✅ IMPORTANT: OTP checksum
          //         otpChecksum: otpChecksum,
          //         idType: this.CommonObj.docType,
          //         token: token,
          //         sessionID: sessionID,
          //         elmStatus: this.elmVerified,
          //         ConsentTCPP: !!(
          //           this.travelerSignupForm.get('acceptTerms')?.value &&
          //           this.travelerSignupForm.get('agreeConcent')?.value
          //         ),
          //         ConsentMarketing:
          //           this.travelerSignupForm.get('acceptPrivacy')?.value,
          //         expiryDate: this.travelerSignupForm.get('docExpiary')?.value,
          //       },
          //     });

          //     this.commonObj.isSubmitting = false;
          //   },
          //   error: () => {
          //     this.commonObj.isSubmitting = false;
          //     this._ToastrApiService.show(
          //       'error',
          //       'Failed to send OTP. Please try again.',
          //     );
          //   },
          // });

          this.createContact();
        }
      });
  }

  onCancel() {
    sessionStorage.removeItem('temp_onboarding_token');
    const user = this.travelerSignupForm.get('userType')?.value;
    this._dataLayerService.onboardingCancleClick('Cancel', user == '0' ? 'Admin' : user == '1' ? 'Travel Arranger' : 'Employee', this.alfursantoggle, this.travelerSignupForm.get('alfursanID')?.value);
    this._Router.navigate(['/']);
  }

  convertDateFormat(dateTime: string): string {
    if (!dateTime) return '';

    const datePart = dateTime.split('T')[0]; // "2004-11-26"
    const [year, month, day] = datePart.split('-');

    return `${day}/${month}/${year}`;
  }
  updateDocumentType(nationality: string, residence: string): void {
    const identityNumberControl = this.travelerSignupForm.get('identityNumber');
    const firstNameControl = this.travelerSignupForm.get('firstname');
    const lastNameControl = this.travelerSignupForm.get('lastname');

    if (!nationality || !residence) {
      this.CommonObj = { docType: '', docName: '' };

      firstNameControl?.enable();
      lastNameControl?.enable();

      identityNumberControl?.clearValidators();
      identityNumberControl?.setErrors(null);
      identityNumberControl?.updateValueAndValidity();
      return;
    }
    if (nationality === 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: 'National ID',
      };
      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^1\d{9}$/),
      ]);
    }
    if (nationality === 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: 'National ID',
      };

      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^1\d{9}$/),
      ]);
    }
    if (nationality !== 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'iqama',
        docName: 'Iqama',
      };

      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^2\d{9}$/),
      ]);
    }
    if (nationality !== 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'passport',
        docName: 'Passport',
      };

      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{6,12}$/),
      ]);
    }

    identityNumberControl?.updateValueAndValidity();
  }

  getImageUrl(path: string): string {
    if (!path) return '';
    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');
    return `${base}/${cleanPath}`;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  sendOTP() {
    const formValue = this.travelerSignupForm.getRawValue();
    const token = localStorage.getItem('access_token');
    const sessionID = localStorage.getItem('session_id');

    const payload: OtpRequestPayload = {
      type: 'email',
      otpAction: 'mobileOrEmailValidation',
      value: formValue.email,
      channel: 'email',
      companyId: 'SAA',
      b2BId: null,
      b2BUserId: null,
      eventName: 'REGISTRATION',
    };

    return this._RegistationUtilitiesService.sendOTPV1(
      token,
      sessionID,
      payload,
    );
  }

  getFakeJson() {
    this.http
      .get('assets/fakeJSON/singleNotVerified.json')
      .subscribe((res: any) => {
        console.log(res);
        this.commonObj.fakeRes = res;
      });
  }
  // Add this method to your component class
  passwordMatchValidator(control: AbstractControl) {
    const confirmPassword = control.value;
    const password = this.travelerSignupForm?.get('password')?.value;

    if (!password || !confirmPassword) {
      return null;
    }

    return password === confirmPassword ? null : { passwordMismatch: true };
  }
  onTermOfUseCheckboxChange(event: MatCheckboxChange) {
    const user = this.travelerSignupForm.get('userType')?.value;
    this._dataLayerService.onboardingCheckboxClick(
      'Terms_of_use_click',
      event.checked,
      user == '0' ? 'Admin' : user == '1' ? 'Travel Arranger' : 'Employee'
    );
  }
  onPrivacyCheckboxChange(event: MatCheckboxChange) {
    const user = this.travelerSignupForm.get('userType')?.value;
    this._dataLayerService.onboardingCheckboxClick(
      'Privacy_policy_click',
      event.checked,
      user == '0' ? 'Admin' : user == '1' ? 'Travel Arranger' : 'Employee'
    );
  }
  onOfferCheckboxChange(event: MatCheckboxChange) {
    const user = this.travelerSignupForm.get('userType')?.value;
    this._dataLayerService.onboardingCheckboxClick(
      'Receive_offers_click',
      event.checked,
      user == '0' ? 'Admin' : user == '1' ? 'Travel Arranger' : 'Employee'
    );
  }
  onToggleChange(event: MatSlideToggleChange) {
    const alFursanControl = this.travelerSignupForm.get('alfursanID');
    const user = this.travelerSignupForm.get('userType')?.value;
    this._dataLayerService.alfursanClick(
      event.checked,
      user == '0' ? 'Admin' : user == '1' ? 'Travel Arranger' : 'Employee'
    );
    if (event.checked) {
      this.alfursantoggle = true;
      alFursanControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{10}$/),
      ]);
    } else {
      this.alfursantoggle = false;
      alFursanControl?.clearValidators();
      alFursanControl?.setValue('');

    }

    alFursanControl?.updateValueAndValidity();
  }

  createContact() {
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const formData = this.travelerSignupForm.getRawValue();
    const ConsentTCPP = !!(
      this.travelerSignupForm.get('acceptTerms')?.value &&
      this.travelerSignupForm.get('agreeConcent')?.value
    );
    const ConsentMarketing =
      this.travelerSignupForm.get('acceptPrivacy')?.value;

    const payload = {
      firstName: formData.firstname,
      lastName: formData.lastname,
      dateOfBirth: this._CommonService.formatDateToYMD(formData.dateOfBirth),
      title: formData.title,
      gender: formData.gender,
      placeOfResidence: formData.residence,
      nationality: formData.Nationality,
      email: formData.email,
      mobile: formData.mobileNumber,
      phoneExtension: formData.countryCode,
      employeeCode: formData.empCode,
      employeeType: formData.userType,
      idNumber: formData.identityNumber,
      idType: this.CommonObj.docType === 'iqama' ? 'Iqama' : this.CommonObj.docType === 'nationalID' ? 'National ID' : this.CommonObj.docType === 'passport' ? 'Passport' : this.CommonObj.docType,
      passportNationality: formData.Nationality,
      designationId: formData.designation,
      departmentId: formData.department ?? null,
      branchId: formData.branch,
      AlFursanId: formData.alfursanID,
      expiryDate: this._CommonService.formatDateToYMD(formData.docExpiary),
      password: this.isFederatedAccount ? null : formData.password,
      elmVerified: this.elmVerified,
      isELMVerified: this.elmVerified,
      elmVerificationDate: this.elmVerificationDate,
      consentTCPP: ConsentTCPP,
      consentMarketingOffers: ConsentMarketing,
      consentLinkAccount: false,
      contactId: '',
      // accountId: '4349855f-8ad6-f011-8544-7ced8d4254b4',
      accountId: formData.accountID,
      vUserDataKey: null,
      flag: 'CREATE',
      companyId: 'SAA',
      otp: null,
      checksum: null,
      type: 'email',
      value: null,
      otpAction: 'mobileOrEmailValidation',
      Channel: 'email',
      B2BId: null,
      B2BUserId: null,
      eventName: null,
      subagentId: formData.subagentId,
      saUserId: formData.saUserId,
      userGuid: formData.userGuid,
    };

    console.log('payload', payload);

    this._RegistationUtilitiesService
      .createNewContact(token, sessionID, null, payload)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.status == 'Success') {
            sessionStorage.removeItem('temp_onboarding_token');
            this.commonObj.isSubmitting = false;

            this._dataLayerService.otpVerificationSuccessOnboarding(
              payload?.type,
              'Thank you for joining Saudia Business',
              'Success',
              payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee'
            );

            const userType = payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee';
            //  if (this.authType !== 'Onboard') {
            //   this._dataLayerService.onboarding_authentication_click(payload?.type, 'Thank you for joining Saudia Business', 0, userType);
            //  }

            if (userType) {
              this._dataLayerService.langdingPageOnboardThankYou(userType);
            }


            this.ThankyouService.show({
              heading: 'Profile successfully created!',
              // description: 'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
              buttonText: 'Go To Login',
              isShowButton: true,
              redirectUrl: '',
            });
          }

          const userType = payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee';
          // if (this.authType !== 'Onboard') {
          //   this._dataLayerService.otpVerificationErrorOnboarding(
          //     payload?.type,
          //     res?.message,
          //     userType
          //   );
          // }

          this.cd.detectChanges();
        },

        error: (err: any) => {

          const userType = payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee';
          this._dataLayerService.errors_occured(err?.error?.message, userType);

          this.commonObj.isSubmitting = false;
          let errorMessage = err?.error?.message || 'Something went wrong';

          try {
            const parsedError = JSON.parse(err?.error?.message);
            errorMessage = parsedError?.details?.[0]?.message?.message || parsedError?.details?.[0]?.message?.Message || errorMessage;
            if (parsedError?.target) {
              errorMessage = `${parsedError?.message} - Target: ${parsedError.target}`;

            }
          } catch (e) { }

          this._dataLayerService.otpVerificationErrorOnboarding(
            payload?.type,
            errorMessage,
            userType
          );

          this._ToastrApiService.show('error', errorMessage);
        },
      });
  }

  getSiteCoreArray(keyString: string) {
    const data = this.content?.[keyString];
    if (data && Array.isArray(data)) {
      this.titles = data.filter((option: any) => option.Key !== 'miss' && option.Key !== 'mstr');
    } else {
      this.titles = data || [];
    }
  }

  updatePhoneNumberValidators() {
    const phoneControl = this.travelerSignupForm.get('mobileNumber');
    const selectedCountry = this.travelerSignupForm.get('countryCode')?.value;
    const countryCode = selectedCountry;
    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91';

    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{10}$/),

      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }

    phoneControl?.updateValueAndValidity();
  }

}
